<template>
  <div>
    <div
      v-if="!advanced"
      class="col-xs-3 col-sm-2 col-md-1"
    >
      <span
        v-if="isCurrency"
        class="currency currency-with-toggle ng-scope"
      >$</span>
      <input
        v-model.number="allDays"
        type="number"
        min="0"
        class="form-control m-b-0"
        :readonly="isReadOnly"
        @input="onBasicDailyCapChange"
        @wheel="$event.target.blur()"
      >
    </div>
    <div class="pull-left p-l-15 m-r-15">
      <button
        type="button"
        class="btn btn-success btn-sm width-100"
        @click="togleAdvanced"
      >
        <span
          v-if="!advanced"
          v-t="'ADVANCED_TEXT'"
        />
        <span
          v-if="advanced"
          v-t="'BASIC_TEXT'"
        />
      </button>
    </div>
    <button
      v-t="'RESET'"
      type="button"
      class="btn btn-primary btn-sm m-r-10"
      @click="resetForm"
    />
    <WeekDayMatrix
      v-if="matrixData && advanced"
      :matrix="matrixData"
      :all-days="allDays"
      :is-currency="isCurrency"
      @matrixDaysNeedsUpdate="matrixDaysNeedsUpdate"
      @matrixDayNeedsUpdate="matrixDayNeedsUpdate"
    />
  </div>
</template>

<script>

import messages from './locales';
import sharedMessages from '@/core/locales';
import WeekDayMatrix from '@/core/components/WeekDayMatrix';
import { capSettingsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  components: {
    WeekDayMatrix
  },
  props: {
    matrix: {
      type: Array,
      default: null
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isCurrency: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      advanced: false,
      allDays: undefined,
      matrixData: []
    };
  },
  watch: {
    matrix: function (newVal, oldVal) {
      if (newVal && Array.isArray(newVal)) {
        this.matrixData = capSettingsService.cloneDayOfWeekCaps(newVal);
      } else {
        this.matrixData = undefined;
      }

      this.reloadMatrix();
    },
  },
  created: function () {
    if (this.matrix) {
      this.matrixData = capSettingsService.cloneDayOfWeekCaps(this.matrix);
    }

    this.loadMatrix();
  },
  methods: {
    loadMatrix() {
      this.advanced = false;

      this.reloadMatrix();
    },
    reloadMatrix: function () {
      if (this.matrixData && this.matrixData.length > 0) {
        this.allDays = undefined;

        for (let day = 0; day < this.matrixData.length; day++) {
          if (this.allSameInColumn(this.matrixData, day)) {
            this.allDays = this.matrixData[day];
            break;
          } else {
            this.allDays = undefined;
            this.advanced = true;
          }
        }

        if (!this.advanced) {
          this.allDays = this.matrixData[0];
        }
      }
    },
    allSameInColumn: function (matrix, day) {
      const compareDay = matrix[day];
      for (let day = 0; day < matrix.length; day++) {
        const element = matrix[day];
        if (!_.isEqual(compareDay, element)) {
          return false;
        }
      }
      return true;
    },
    togleAdvanced: function () {
      if(this.matrixData == undefined || this.matrixData?.length == 0){
        //ensure if its going to be advanced that we have a matrix.
        this.matrixData = capSettingsService.createEmptyDayOfWeekCaps();
      }
      if (this.advanced) {
        //if it's moving to basic, reset the matrix
        this.resetMatrix();
      }
      this.advanced = !this.advanced;
    },
    onBasicDailyCapChange() {
      this.matrixDaysNeedsUpdate(this.allDays);
    },
    matrixDayNeedsUpdate: function (updateData) {
      this.matrixData[updateData.day] = updateData.value;
      this.bubbleUpMatrixUpdate();
    },
    matrixDaysNeedsUpdate(updateValue) {
      if (!this.matrixData) {
        return;
      }

      for (let day = 0; day < 7; day++) {
        this.matrixData[day] = updateValue;
      }
      this.bubbleUpMatrixUpdate();
    },
    resetForm() {
      this.allDays = undefined;
      this.advanced = false;
      this.resetMatrix();
    },
    resetMatrix: function () {
      for (let day = 0; day < this.matrixData.length; day++) {
        this.matrixData[day] = undefined;
      }

      this.bubbleUpMatrixUpdate();
    },
    bubbleUpMatrixUpdate() {
      this.$emit('weekDayMatrixUpdated', this.matrixData);
    },

  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>